import React from 'react';

export default function Header() {
  return (
    <div className='header'>
        <h1>TextEditz</h1>
        <p><b>Welcome!</b>Easily convert your text to any format you require. Simply paste your text below and select the desired format buttons to transform it instantly and effortlessly. Achieve the perfect format in seconds.
        </p>
        
    </div>
  )
}